export const ru = {
    'be-sure-no-error': 'Вы попали на несуществующую страницу',
    info:
        'Вероятно, это произошло из-за опечатки или неправильной раскладки клавиатуры',
    'tell-us': 'Если вы прошли сюда по ссылке, поделитесь ею с нами, пожалуйста'
};
